export const assessmentKey = 'assessment';
